<template>
  <div class="grid-x align-middle form">
    <div class="cell small-12 large-auto">
      <input 
        :value="selectedFilters.query"
        @input="debounceInput"
        type="text" 
        placeholder="Filter" 
        class="text no-margin size-l">
    </div>

    <div
      v-for="(filter, index) in config.filters" 
      :key="index"
      class="cell small-6 large-shrink">
      <dropdown-filter
        :value="getFilterValue(filter)"
        :options="getFilterOptions(filter)"
        @apply-filter="$emit('set-filter', $event)">
        <template #button>
          <div class="grid-x align-middle">
            <div class="cell auto">
              {{ filter.label }}
            </div>
            <div class="cell shrink">
              <span v-html="$icons.get('caret_down', 'small')" style="margin-left:.3rem"></span>
            </div>
          </div>
        </template>
      </dropdown-filter>
    </div>
    <div class="cell small-12 large-shrink">
      <date-range-filter
        :date-range="selectedFilters.date_range"
        @apply-filter="$emit('set-filter', $event)">
      </date-range-filter>
    </div>
  </div>
</template>

<script>
import debounce from 'debounce'
import DateRangeFilter from '@/Filter/DateRangeFilter.vue'
import DropdownFilter from '@/Filter/DropdownFilter.vue'

export default {
  name: 'Filters',
  components: {
    DateRangeFilter, DropdownFilter
  },
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  methods: {
    debounceInput: debounce(function (e) {
      const value = e.target.value
      this.$emit('set-filter', { name: 'query', data: value })
    }, 1000),
    getFilterValue (filter) {
      if (filter.name in this.params.filters) {
        return this.params.filters[filter.name]
      }
      return false
    },
    getFilterOptions (filter) {
      return {
        name: filter.name,
        multiple: true,
        title: filter.label,
        source: filter.items
      }
    }
  },
  computed: {
    config () {
      return this.$root.$options.config
    },
    selectedFilters () {
      return this.params.filters
    }
  }
}
</script>
